var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrownOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26438 2.67665C7.56745 2.07051 8.43245 2.07051 8.73552 2.67665L11.2029 7.61144L14.7066 5.27564C15.3162 4.86923 16.1129 5.40274 15.9692 6.12119L14.5701 13.1168C14.4932 13.5012 14.1557 13.7779 13.7637 13.7779H2.23622C1.8442 13.7779 1.50668 13.5012 1.4298 13.1168L0.0306797 6.12119C-0.113009 5.40275 0.683661 4.86922 1.29328 5.27564L4.79699 7.61144L7.26438 2.67665ZM7.99995 4.44781L5.77597 8.89579C5.55474 9.33823 4.9958 9.48667 4.58421 9.21227L1.74967 7.32258L2.75074 12.3279H13.2492L14.2502 7.32258L11.4157 9.21227C11.0041 9.48666 10.4452 9.33823 10.2239 8.89579L7.99995 4.44781Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrownOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CrownOutline.993360dab67d9159486737252c06cbb8.svg";